import React, { createContext, useContext } from "react";

const DEFAULT = { slug: "exchange-alliance", name: "The Exchange Alliance", accent: "#D4AF37", cardCopy: {}, isAdmin: false, onEditCard: null, tourColors: null };
const Ctx = createContext(DEFAULT);

export function DemoBrandProvider({ value, children }) {
  return <Ctx.Provider value={{ ...DEFAULT, ...value }}>{children}</Ctx.Provider>;
}

export const useDemoBrand = () => useContext(Ctx);

// Swap the template company name for the demo's own.
export const possessive = (name) => `${name}${/s$/i.test(name) ? "'" : "'s"}`;
export const brandText = (text, name) => (text && name ? text.replaceAll("THE EXCHANGE ALLIANCE's", possessive(name)).replaceAll("THE EXCHANGE ALLIANCE", name) : text);
